import React, { useEffect, useState } from "react";

const CustomSingleSelect = ({ items, onChange, value }) => {
  const [selectedValue, setSelectedValue] = useState(value ? value : "");
  const handleChange = (event) => {
    const selectedValue = event.target.value;

    setSelectedValue(selectedValue);
    if (onChange) onChange(selectedValue);
  };
  useEffect(() => {
    setSelectedValue(value);
  }, [value]);
  return (
    <select
      value={selectedValue}
      onChange={handleChange}
      className="select_category"
    >
      <option value="">...Select an option...</option>
      {items.map((item, index) => (
        <option key={index} value={item.value}>
          {item.value}
        </option>
      ))}
    </select>
  );
};

export default CustomSingleSelect;
